import styled from 'styled-components';
import UserIcon from '~/assets/svgs/user.svg';
import ClockIcon from '~/assets/svgs/clock.svg';
import ProductIcon from '~/assets/svgs/product.svg';
import HeartIcon from '~/assets/svgs/heart.svg';
import MessageIcon from '~/assets/svgs/message.svg';

import NavigationItem from './NavigationItem';
import { useLocation } from 'react-router-dom';

const Navigation = () => {
  const { pathname } = useLocation();

  return (
    <S.Nav>
      {NavList.map(({ label, icon, href }) => (
        <NavigationItem
          key={href}
          label={label}
          active={pathname.startsWith(href)}
          icon={icon}
          href={href}
        />
      ))}
    </S.Nav>
  );
};

const S = {
  Nav: styled.nav`
    background: #fff;
  `,
  UserIcon: styled(UserIcon)`
    width: 15px;
    height: 16px;
  `,
  ClockIcon: styled(ClockIcon)`
    width: 18px;
    height: 17px;
  `,
  ProductIcon: styled(ProductIcon)`
    width: 16px;
    height: 16px;
  `,
  HeartIcon: styled(HeartIcon)`
    width: 20px;
    height: 17px;
  `,
  MessageIcon: styled(MessageIcon)`
    width: 20px;
    height: 18px;
  `,
};

const NavList = [
  { label: 'Team', icon: <S.UserIcon />, href: '/team' },
  { label: 'Dashboard', icon: <S.ClockIcon />, href: '/dashboard' },
  { label: 'Products', icon: <S.ProductIcon />, href: '/products' },
  { label: 'Favorites', icon: <S.HeartIcon />, href: '/favorites' },
  { label: 'Inbox', icon: <S.MessageIcon />, href: '/inbox' },
];

export default Navigation;
